import {ChangeDetectorRef, Injector, ViewContainerRef} from '@angular/core';
import {Observable} from 'rxjs';
import {DynamicComponentCreationOptions} from '../../../components/dynamic-component';
import {ModalService} from '../../../components/modal';
import {AlertFn} from '../../../components/response-errors/response-error-code-msg';
import {WidgetInnerAlertComponent} from './widget-inner-alert.component';

export const showWidgetInnerAlert: AlertFn = (
    title: string,
    message: string,
    titleTranslate: boolean,
    messageTranslate: boolean,
    injector: Injector,
    vcRef?: ViewContainerRef,
    destroyWhen?: Observable<unknown>
): void => {
    const changeDetectorRef = injector.get(ChangeDetectorRef);
    const modalService = injector.get(ModalService);
    const options: DynamicComponentCreationOptions<WidgetInnerAlertComponent> = {
        injector,
        configure: {
            title,
            message,

            titleTranslate,
            messageTranslate
        }
    };

    if (vcRef) {
        options.place = {
            viewContainerRef: vcRef
        };
    }

    if (destroyWhen) {
        options.destroyWhen = destroyWhen;
    }

    modalService.open(WidgetInnerAlertComponent, options);

    changeDetectorRef.markForCheck();
};
